function fnCarousel( i, oSection ) {

	var oSection				= $( oSection );
	var oCarousel				= oSection.find( '.owl-carousel' );

	$( oCarousel ).owlCarousel({
		items: 				1,
		smartSpeed: 		600,
		dots: 				true,
		nav: 				false,
		loop: 				false,
		margin: 			0,
		autoHeight: 		true,
		autoWidth: 			false,
		animateOut: 		'fadeOut',
		mouseDrag: 			false,
		stagePadding: 		0,
		autoplay: 			true,
		autoplayTimeout: 	5000,
		autoplayHoverPause: false
	});

}
